import { sortBy } from 'lodash';
import { REORDER_LISTINGS, UPDATE_PINNED_LISTINGS } from '../actions';

export default function(state = {}, action) {
  switch (action.type) {
  case UPDATE_PINNED_LISTINGS: {
    const { pinnedListings } = action.payload;
    return pinnedListings;
  }
  case REORDER_LISTINGS: {
    const { dragIndex, hoverIndex, key } = action.payload;
    const pinnedListings = [...state];
    if (key == 'reverse') {
      return pinnedListings.reverse();
    } else if (key) {
      return sortBy(pinnedListings, key);
    } else {
      const dragItem = pinnedListings[dragIndex];
      
      pinnedListings.splice(dragIndex, 1);
      pinnedListings.splice(hoverIndex, 0, dragItem);
    }
    return pinnedListings;
  }
  }
  return state;
}
